var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibilityOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0848 8.7874C12.366 14.9047 3.64834 15.0112 0.948874 8.93742C0.683709 8.34078 0.683709 7.65972 0.948874 7.06308C3.64834 0.989291 12.366 1.09578 15.0848 7.2131C15.3051 7.70853 15.3051 8.29198 15.0848 8.7874Z",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98233 10.4442C9.33171 10.4442 10.4256 9.35026 10.4256 8.00088C10.4256 6.65151 9.33171 5.55762 7.98233 5.55762C6.63295 5.55762 5.53906 6.65151 5.53906 8.00088C5.53906 9.35026 6.63295 10.4442 7.98233 10.4442Z",
    stroke: "#424242",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOn);
export default __webpack_public_path__ + "static/media/visibility-on.312b3bb806eafb1c3e0a04f11153ce19.svg";
export { ForwardRef as ReactComponent };